export var FreeShippingReason;
(function (FreeShippingReason) {
    FreeShippingReason["FIRST_ORDER_FREE_SHIPPING"] = "FIRST_ORDER_FREE_SHIPPING";
    /**
     * @deprecated
     */
    FreeShippingReason["FIRST_ORDER_FREE_SHIPPING_PERIOD"] = "FIRST_ORDER_FREE_SHIPPING_PERIOD";
    FreeShippingReason["FIRST_APP_ORDER_FREE_SHIPPING"] = "FIRST_APP_ORDER_FREE_SHIPPING";
    FreeShippingReason["EMPLOYEE_GRANTED_FREE_SHIPPING"] = "EMPLOYEE_GRANTED_FREE_SHIPPING";
    FreeShippingReason["FAIRE_DIRECT_FREE_SHIPPING"] = "FAIRE_DIRECT_FREE_SHIPPING";
    FreeShippingReason["SELECT_FREE_SHIPPING"] = "SELECT_FREE_SHIPPING";
    FreeShippingReason["NEXT_ORDER_FREE_SHIPPING_INTEGRATION_LINKED"] = "NEXT_ORDER_FREE_SHIPPING_INTEGRATION_LINKED";
    /**
     * @deprecated
     */
    FreeShippingReason["UK_WELCOME_FREE_SHIPPING"] = "UK_WELCOME_FREE_SHIPPING";
    /**
     * @deprecated
     */
    FreeShippingReason["NLD_WELCOME_FREE_SHIPPING"] = "NLD_WELCOME_FREE_SHIPPING";
    /**
     * @deprecated
     */
    FreeShippingReason["UK_EU_BRANDS_FREE_SHIPPING"] = "UK_EU_BRANDS_FREE_SHIPPING";
    FreeShippingReason["INTERNATIONAL_WELCOME_FREE_SHIPPING"] = "INTERNATIONAL_WELCOME_FREE_SHIPPING";
    /**
     * @deprecated
     */
    FreeShippingReason["ANZ_FIRST_DOMESTIC_ORDER_FREE_SHIPPING"] = "ANZ_FIRST_DOMESTIC_ORDER_FREE_SHIPPING";
    FreeShippingReason["NEW_ARRIVALS_FREE_SHIPPING"] = "NEW_ARRIVALS_FREE_SHIPPING";
})(FreeShippingReason || (FreeShippingReason = {}));
